var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisclaimerFileIconAccuracyEnhanceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -0.089,
    y1: 1.104,
    x2: 0.849,
    y2: 0.187,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#398aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.613,
    stopColor: "#69a2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.852,
    stopColor: "#70efde"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffebd6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "convertFaceIcon",
    transform: "translate(-744 -266)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_342",
    "data-name": "Rectangle 342",
    width: 40,
    height: 40,
    transform: "translate(744 266)",
    fill: "#69a2ff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_450",
    "data-name": "Path 450",
    d: "M16.291,15.291l-2.659,8.974-2.659-8.974L2,12.632l8.974-2.659L13.632,1l2.659,8.974,8.974,2.659-8.974,2.659m10.635,7.644,6.647-3.656-3.656,6.647,3.656,6.647-6.647-3.656L20.28,32.574l3.656-6.647L20.28,19.28l6.647,3.656M15.294,25.927l-2.825,4.985L15.294,35.9l-4.985-2.825L5.324,35.9l2.825-4.985L5.324,25.927l4.985,2.825,4.985-2.825",
    transform: "translate(745.324 266.662)",
    fill: "url(#linear-gradient)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclaimerFileIconAccuracyEnhanceIcon);
export default __webpack_public_path__ + "static/media/disclaimerFileIconAccuracyEnhanceIcon.df4168c8f38be1d583390c49441bd5ae.svg";
export { ForwardRef as ReactComponent };